/**
 * Get the image size for the image listing page, given the screen size
 * @param {string} screenSize The effective screen size
 * @returns {string} The individual image size
 */
export function getImgSize(screenSize: string) {

  const imageMap = {
    '1080x1920': '255x255!', // Galaxy S5
    '1242x2208': '255x255!', // iPhone 7+/8+
    '750x1334': '185x185!', // iPhone 7/8
    '1125x2436': '280x280!', // iPhone X
    '1440x2560': '355x355!', // Galaxy Note 5 / S7 / S7 Edge
    '1440x2960': '355x355!', // Galaxy S8 / S8+
    '1438x2880': '355x355!', // Pixel 2 XL
    '1078x1918': '255x255!', // Pixel 2
  };

  return imageMap[screenSize];
}


// WEBPACK FOOTER //
// ./src/utils/content/image-size.utils.ts